import { useEffect, useState } from 'react';
import { Network, Activity, CheckCircle, XCircle } from 'lucide-react';

interface Interface {
  id: string;
  name: string;
  type: 'ethernet' | 'bond' | 'vlan';
  ipAddress: string;
  subnetMask: string;
  gateway: string;
  mtu: number;
  linkState: 'up' | 'down';
  speedMbps: number;
}

export default function NetworkPage() {
  const [interfaces, setInterfaces] = useState<Interface[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/v1/network', { credentials: 'include' })
      .then((r) => r.json())
      .then((res) => setInterfaces(res.data || []))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="p-8 text-center text-slate-500">Loading network interfaces...</div>;

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-slate-900 dark:text-white">Network</h1>
        <button className="px-4 py-2 bg-sky-600 hover:bg-sky-700 text-white text-sm font-medium rounded-md transition-colors">
          Configure Interface
        </button>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {interfaces.map((iface) => (
          <div key={iface.id} className="rounded-lg border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-slate-900">
            <div className="flex items-center justify-between mb-3">
              <div className="flex items-center gap-2 font-medium text-slate-900 dark:text-white">
                <Network size={18} /> {iface.name}
              </div>
              {iface.linkState === 'up' ? <CheckCircle size={18} className="text-emerald-500" /> : <XCircle size={18} className="text-rose-500" />}
            </div>
            <div className="space-y-1 text-sm text-slate-600 dark:text-slate-400">
              <div>IP: {iface.ipAddress}/{iface.subnetMask}</div>
              <div>Gateway: {iface.gateway}</div>
              <div>MTU: {iface.mtu} | Speed: {iface.speedMbps} Mbps</div>
              <div className="flex items-center gap-1 text-xs"><Activity size={12} /> {iface.type}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
